import React from 'react';

interface SliderPrevArrowProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const SliderPrevArrow = ({ className, style, onClick }: SliderPrevArrowProps) => {
  return (
    <div
      className={className}
      style={{
        ...style,
        display: 'block',
        background: 'black',
        borderRadius: '50%',
        padding: '10px',
      }}
      onClick={onClick}
    />
  );
};

export default SliderPrevArrow;
